/* globals vocento, noticiaid */
const app = Voonto.getInstance();

class TeInteresa
{
	constructor(form) {
		this.libPath = app.lookup('vocento.config.nibara').libPath;
		if (this.libPath === undefined) {
			throw 'nibara libPath config is empty';
		}
		this.isMobile = Voonto.is.mobile();
		this.isTablet = Voonto.is.tablet();
	}

	load($container) 
	{
        const Logger = nibara.logger;
		var comscore = app.lookup('vocento.tracking.comscore');
		var tc = comscore.voc_tcnew ? comscore.voc_tc : null;
		var se = comscore.voc_se;
		if (typeof noticiaid === 'undefined' || !noticiaid || !tc || !se) {
			Logger.error('No se puede cargar te-interesa');
			return false;
		}

		var url = "/ajax/v2/te-interesa.html?recid="+noticiaid+"&voc_tc="+tc +"&voc_se="+se;
		Voonto.$.ajax({
			"type": "get",
			"url": url,
			"timeout": 20000
		}).fail(() => {
			Logger.error('No se puede cargar te-interesa');
			this.mobileShowToolbar();
		}).done((html) => {
			if (html) {
				this.mobileHideToolbar();

				$container.html(html);
				this.swiper($container.find('.swiper-container'));

				this.mobileEvents($container);
			} else {
				this.mobileShowToolbar();
			}
		});
	}

	mobileShowToolbar()
	{
		if (this.isMobile && Voonto.SocialToolbar) {
			Voonto.SocialToolbar.enable();
		}
	}

	mobileHideToolbar()
	{
		if (this.isMobile && Voonto.SocialToolbar) {
			Voonto.SocialToolbar.disable();
		}
	}

	mobileEvents($container)
	{
        const Logger = nibara.logger;
		if (this.isMobile ) {
			this.mobileHideToolbar();
			$container.find('.cerrar').click(() => {
				$container.hide();
				this.mobileShowToolbar();
			});

            Voonto.$('.noticia').click(function () {
                Logger.info('[Breaking News] click Te-Interesa');
                let type = Voonto.$(this).data('type');

                Logger.info('[Breaking News] type: ', type);
                Logger.info('[Breaking News] href: ', Voonto.$(this).data('href'));

                window.location.href = Voonto.$(this).data('href');
            });
		}
	}

	swiper($elm)
	{
        const Logger = nibara.logger;
		Logger.info('Te-Interesa: Cargado JQuery-UI');
		$elm.find('.swiper-prev-row-bn').css('zIndex',99);
		$elm.find('.swiper-next-row-bn').css('zIndex',99);
		$elm.find('.swiper-wrapper').attr('style','min-height: 1px !important;');

		let numElem = 0;
		$elm.find("[id^='j-swiper-slide-']").each( () => {
			numElem++;
		});
		Logger.info('Te-Interesa: Número elementos: ' + numElem);

		let IntID = this.setTimer(numElem, $elm);

		$elm.find('.swiper-prev-row-bn').on('click', () => {
			Logger.info('Te-Interesa: Noticia anterior');
			clearInterval(IntID);
			IntID = this.setTimer(numElem, $elm);
			this.changeSlide('anterior', numElem, $elm);
		});

		$elm.find('.swiper-next-row-bn').on('click', () => {
			Logger.info('Te-Interesa: Noticia siguiente');
			clearInterval(IntID);
			IntID = this.setTimer(numElem, $elm);
			this.changeSlide('siguiente', numElem, $elm);
		});
	}

    setTimer (numElem, $elm) {
        const Logger = nibara.logger;
		let i = setInterval( () => {
			Logger.info('Te-Interesa: setInterval - Noticia siguiente');
			this.changeSlide('interval', numElem, $elm);
		}, 7000); // 7000ms = 7 segartSlider, 4000);
		return i;
	}

    changeSlide (action, numElem, $elm) {
        const Logger = nibara.logger;
		let id = Voonto.$("[id^='j-swiper-slide-']:visible").data('pos');
		Logger.info('Te-Interesa: ID Visible: ' + id);

		let newId = id - 1;
		if (action === 'anterior') {
			if (id <= 1) {
				return false;
			}
		} else {
			newId = id + 1;
			if (action === 'interval') {
				if (id === numElem) {
					newId = 1;
					id = 1;
				}
			}

			if (id >= numElem) {
				return false;
			}
		}

		$elm.find("[id^='j-swiper-slide-']").each(function (i,e) {
			if (newId === Voonto.$(e).data('pos')) {
				Voonto.$(e).show();
			} else {
				Voonto.$(e).hide();
			}
		});
	}
}

export default TeInteresa;



// WEBPACK FOOTER //
// ./src/scripts/article/te-interesa.js